<script setup>
  import { computed, ref } from 'vue'
  import { useWishlistStore } from '@/stores/wishlist'
  import { storeToRefs } from 'pinia'
  import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue'

  const props = defineProps({
    nodeId: String
  })

  const store = useWishlistStore()
  const { hasWishlistAccepted } = storeToRefs(store)
  const loading = ref(false)

  const toggleWishlist = async (nodeId) => {
    if (!hasWishlistAccepted.value) {
      await store.showWishlistWarning(nodeId)
      return
    }
    if (itemOnWishlist.value) {
      await store.removeItem(nodeId)
      return
    }
    loading.value = true
    setTimeout(() => {
      loading.value = false
    }, 3000)
    await store.addItem(nodeId)
  }

  const itemOnWishlist = computed(() => {
    return store.hasItem(props.nodeId)
  })

</script>

<template>
  <button
    class="add-to-wishlist overflow-hidden relative w-full max-w-52 h-10 flex justify-center items-center border text-sm rounded-full hover:bg-primary hover:text-white transistion-all duration-300"
    :class="itemOnWishlist ? 'bg-secondary border-secondary text-body' : 'bg-white text-body border-primary'"
    @click="toggleWishlist(nodeId)"
    aria-label="Termin zur Merkliste hinzufügen"
  >
    <AppIcon
      v-if="!itemOnWishlist"
      name="Heart"
      class="mr-1"
    />
    <AppIcon
      v-else
      name="HeartFilled"
      class="mr-1"
    />
    {{ itemOnWishlist ? 'Termin entfernen' : 'Termin Merken' }}
    <Transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="loading"
        class="button-loader bg-success z-20 h-full w-full absolute top-0 left-0 flex justify-center items-center"
      >
        <LottieAnimation
          path="./themes/custom/eyedea/assets/lottie/success-wishlist.json"
          class="-translate-y-1"
          :auto-play="true"
          :loop="false"
          :height="72"
          :width="72"
        />
      </div>
    </Transition>
  </button>
</template>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
    opacity: 1;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  .add-to-wishlist {
    &:hover {
      :deep(svg path) {
        @apply fill-white !important;
      }
    }
  }
  .add-to-wishlist :deep(svg path) {
   @apply transition-colors duration-300 fill-body !important;
  }
  .button-loader {
    :deep(svg path) {
    }
  }
</style>


